import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import img from "../../../assets/Icon/approved.png";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const EvaluationPost = () => {
  let history = useHistory();
  const [buffer, setBuffer] = useState(true);

  const joinLive = (room_id) => {
    history.push({
      pathname: "/superstar/videocall",
      search: `id=${room_id}`,
    });
  };

  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState([]);

  // Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/star/learning_session/evaluation`).then((res) => {
      setBuffer(false);
      if (res.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Evaluation Learning Session"
        image={img}
        count={count}
      />
      {buffer ? (
          <LoaderPost />
        ) : (
      <AllModuleData
        data={event_data}
        urlLink={`/superstar/learning-session/evaluation`}
      />
      )}
    </>
  );
};

export default EvaluationPost;
